var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBadges(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 130,
    height: 87,
    viewBox: "0 0 130 87"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon-badges_svg__a",
    width: "136.8%",
    height: "132%",
    x: "-13.8%",
    y: "-16%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.261090472 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "icon-badges_svg__b",
    width: "142.1%",
    height: "147.5%",
    x: "-21.1%",
    y: "-23.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.399038462 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "icon-badges_svg__c",
    d: "M0 .156h37.141v33.459H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6645E0",
    d: "M35.82 34.225c10.394-9.351 21.39-15.08 32.579-24.246l1.244-1.033c8.24-6.937 26.585-4.868 33.172 11.316C111.985 42.79 105.5 70 83.012 79.003 58.875 88.667 5.5 61.5 35.819 34.225z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-badges_svg__a)",
    transform: "translate(23 2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEFFF4",
    d: "M33.955 65.307l31.04.017-.23-24.547-31.04-.015z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F9F9C",
    d: "M60.98 50.04l-12.593-.006-.028-3.036 12.592.006zm.082 8.697l-12.592-.006-.029-3.036 12.592.006z",
    opacity: 0.301
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#307C76",
    d: "M44.797 57.528a2.93 2.93 0 01-2.95 2.95c-1.643 0-2.989-1.323-3.004-2.953a2.93 2.93 0 012.95-2.95c1.643 0 2.988 1.323 3.004 2.953m-3.04-6.612l2.405 1.249-.482-2.643 1.918-1.869-2.68-.388-1.219-2.404-1.172 2.403-2.671.385 1.953 1.872-.432 2.641z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8EFDC",
    d: "M18.688 44.253L45.02 27.818 31.817 7.123 5.485 23.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F9F9C",
    d: "M33.515 16.984l-10.682 6.668-1.632-2.56 10.682-6.667zm4.68 7.332l-10.683 6.668-1.633-2.56 10.682-6.667z",
    opacity: 0.312
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#307C76",
    d: "M23.76 31.91a2.93 2.93 0 01-.938 4.064c-1.394.871-3.236.462-4.113-.912a2.93 2.93 0 01.938-4.065c1.394-.87 3.236-.46 4.113.913m-6.082-3.997l2.701-.215-1.809-1.985.637-2.602-2.478 1.09-2.308-1.392.279 2.66-2.062 1.74 2.649.554 1.033 2.469z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-badges_svg__b)",
    transform: "rotate(36 8.878 92.037)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon-badges_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-badges_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#75CFC0",
    d: "M0 10.349l7.814 23.266 29.327-10.194L29.326.155z",
    mask: "url(#icon-badges_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F9F9C",
    d: "M28.618 10.209l-11.896 4.135-.967-2.878 11.896-4.135zm2.768 8.243L19.49 22.587l-.967-2.878 11.896-4.135z",
    opacity: 0.461
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#307C76",
    d: "M15.648 22.651c.52 1.545-.319 3.235-1.872 3.775a2.928 2.928 0 01-3.753-1.82c-.519-1.545.32-3.236 1.873-3.776a2.928 2.928 0 013.752 1.821m-4.917-5.288l2.658.397-1.273-2.354 1.233-2.409-2.65.513-1.896-1.886-.364 2.671-2.405 1.244 2.425 1.137.409 2.654z"
  }))))));
}

export default __webpack_public_path__ + "f0f12a394adceb08381ef3888820f375.svg";
export { SvgIconBadges as ReactComponent };